import React, { PropTypes } from 'react';
import StyleButton from './StyleButton.js.jsx';

var MEDIA_STYLES = [
  {label: <i key={'picture'} className="fa fa-picture-o"/>, style: 'unstyled'}
];

const MediaControls = (props) => {
  var currentStyle = props.editorState.getCurrentInlineStyle();
  return (
    <div className="RichEditor-controls">
      {MEDIA_STYLES.map((type, i) =>
        <StyleButton
          key={i}
          active={currentStyle.has(type.style)}
          label={type.label}
          onToggle={props.onToggle}
          style={type.style}
        />
      )}
    </div>
  );
};

export default MediaControls;



// WEBPACK FOOTER //
// global/components/forms/editorComponents/MediaControls.js.jsx